/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ManagedAgent, ManagedAgent$inboundSchema } from "./managedagent.js";

/**
 * A page of managed agents, ordered by name.
 */
export type ListAgentsResult = {
  /**
   * The agents in this page.
   */
  items: Array<ManagedAgent>;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListAgentsResult$inboundSchema: z.ZodMiniType<
  ListAgentsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(ManagedAgent$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listAgentsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentsResult' from JSON`,
  );
}
